import { styled } from '@mui/system';
import { Props } from './types';

type T = Pick<Props, 'labelPalette'>;

type U = Pick<Props, 'labelInline'>;

export const SIZES = {
  // XXSMALL: 20,
  // XSMALL: 30,
  SMALL: 40,
  MEDIUM: 50
  // LARGE: 60,
  // XLARGE: 70,
  // XXLARGE: 80,
};

export const Label = styled('div')<U>`
  display: ${({ labelInline }) => {
    if (labelInline) {
      return 'flex';
    }
    return 'block';
  }};
`;

export const Title = styled('div')<T>`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  margin: 0 0 6px;
  display: grid;
  grid-template-areas: 'icon label lock';
  grid-template-columns: auto 1fr auto;
  align-items: center;

  color: ${({ labelPalette }) => {
    switch (labelPalette) {
      case 'primary': {
        return '#fff';
      }
      default: {
        return '#888';
      }
    }
  }};

  font-weight: ${({ labelPalette }) => {
    switch (labelPalette) {
      case 'primary': {
        return 'normal';
      }
      default: {
        return 'bolder';
      }
    }
  }};

  & svg {
    font-size: 15px;
    margin-right: 9px;
  }
`;

export const Icon = styled('div')`
  grid-area: icon;
`;

export const Name = styled('div')`
  grid-area: label;
`;

export const Lock = styled('div')`
  grid-area: lock;
`;

export const Error = styled('div')`
  color: #ea475c;
  margin-top: 10px;
`;
